// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "form-JQhVk";
var _5 = "form__item-qAqnG";
var _6 = "row__inputs-3LRkQ";
var _7 = "remove-3hoOJ";
var _8 = "select__item-KQsn9";
var _9 = "footer-giICT";
var _a = "select--wpzj";
var _b = "select__label__focused-2kIVp";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "form", _5 as "form__item", _6 as "row__inputs", _7 as "remove", _8 as "select__item", _9 as "footer", _a as "select", _b as "select__label__focused" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "form": _4, "form__item": _5, "row__inputs": _6, "remove": _7, "select__item": _8, "footer": _9, "select": _a, "select__label__focused": _b }
